import * as React from 'react';
import * as styles from './Link.css';

export type ILinkProps = Omit<React.ComponentPropsWithoutRef<'a'>, 'className' | 'style'>;

export const Link: React.FC<ILinkProps> = props => {
  const { children } = props;

  return (
    // eslint-disable-next-line react/jsx-no-target-blank
    <a {...props} className={styles['link']}>
      {children}
    </a>
  );
};
